import styled, { css } from "styled-components";
import { fontMedium, fontNormal } from "../../_static/Typography";
import buildColor from "../../_static/ColorPalette";

export const Container = styled.div`
  border-radius: 2px;
  ${({ isChecked }) =>
    isChecked
      ? css`
          background-color: ${buildColor("blue_accent", "100")};
          border: 2px solid ${buildColor("blue_accent", "500")};
        `
      : css`
          background-color: ${buildColor("white", "100")};
          border: 1px solid ${buildColor("blue", "100")};
        `}
`;

export const Wrapper = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  ${({ isChecked }) =>
    !isChecked &&
    css`
      border: 1px solid transparent;
    `}
`;

export const TextContainer = styled.div`
  margin-right: 12px;
  flex-grow: 1;
`;

export const Title = styled.p`
  font-family: ${fontMedium};
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  color: ${buildColor("grey", "900")};
`;

export const Description = styled.p`
  font-family: ${fontNormal};
  font-size: 14px;
  line-height: 18px;
  color: ${buildColor("grey", "800")};
  margin-top: 8px;
`;

export const Button = styled.button`
  cursor: pointer;
  outline: none;
  border: none;
  background-color: transparent;
  font-family: ${fontNormal};
  font-size: 12px;
  height: 17px;
  color: ${buildColor("grey", "800")};
  text-decoration: underline;
  margin-top: 8px;
`;

export const CheckBoxContainer = styled.div`
  & > div {
    margin-bottom: 0;
  }
`;
